import * as storage from './localStorage'
import * as pageSourceCode from '@scripts/PageSourceCode';
export function init() {
    return new Promise(async (resolve) => {
        await storage.init();
        resolve();
    })
}

// ===== Start Config File =====

// Config ShowError
export function saveConfigShowError(value) {
    storage.saveConfigShowError(value);
}

export function destroyConfigShowError() {
    storage.destroyConfigShowError();
}

export function getConfigShowError() {
    return storage.getConfigShowError();
}

// Config Token_ValidateMinutesInterval
export function saveConfigValidateMinutesInterval(value) {
    storage.saveConfigValidateMinutesInterval(value);
}

export function destroyConfigValidateMinutesInterval() {
    storage.destroyConfigValidateMinutesInterval();
}

export function getConfigValidateMinutesInterval() {
    return storage.getConfigValidateMinutesInterval();
}

// Config Token_RenewMinutes
export function saveConfigRenewMinutes(value) {
    storage.saveConfigRenewMinutes(value);
}

export function destroyConfigRenewMinutes() {
    storage.destroyConfigRenewMinutes();
}

export function getConfigRenewMinutes() {
    return storage.getConfigRenewMinutes();
}

// Config LogInfoDevice
export function saveConfigLogInfoDevice(value) {
    storage.saveConfigLogInfoDevice(value);
}

export function destroyConfigLogInfoDevice() {
    storage.destroyConfigLogInfoDevice();
}

export function getConfigLogInfoDevice() {
    return storage.getConfigLogInfoDevice();
}

// Config EncryptStorage
export function saveConfigEncryptStorage(value) {
    storage.saveConfigEncryptStorage(value);
}

export function destroyConfigEncryptStorage() {
    storage.destroyConfigEncryptStorage();
}

export function getConfigEncryptStorage() {
    return storage.getConfigEncryptStorage();
}

// Config EncryptKey
export function saveConfigEncryptKey(value) {
    storage.saveConfigEncryptKey(value);
}

export function destroyConfigEncryptKey() {
    storage.destroyConfigEncryptKey();
}

export function getConfigEncryptKey() {
    return storage.getConfigEncryptKey();
}

// Config EncryptKeyPassword
export function saveConfigEncryptKeyPassword(value) {
    storage.saveConfigEncryptKeyPassword(value);
}

export function destroyConfigEncryptKeyPassword() {
    storage.destroyConfigEncryptKeyPassword();
}

export function getConfigEncryptKeyPassword() {
    return storage.getConfigEncryptKeyPassword();
}

// Config EntraId_RootBase
export function saveConfigRootBase(value) {
    storage.saveConfigRootBase(value);
}

export function destroyConfigRootBase() {
    storage.destroyConfigRootBase();
}

export function getConfigRootBase() {
    return storage.getConfigRootBase();
}

// Config EntraId_ClientId
export function saveConfigClientId(value) {
    storage.saveConfigClientId(value);
}

export function destroyConfigClientId() {
    storage.destroyConfigClientId();
}

export function getConfigClientId() {
    return storage.getConfigClientId();
}

// Config EntraId_TenantId
export function saveConfigTenantId(value) {
    storage.saveConfigTenantId(value);
}

export function destroyConfigTenantId() {
    storage.destroyConfigTenantId();
}

export function getConfigTenantId() {
    return storage.getConfigTenantId();
}

// Config OnlineHelpFrenchLink
export function saveConfigOnlineHelpFrenchLink(value) {
    storage.saveConfigOnlineHelpFrenchLink(value);
}

export function destroyConfigOnlineHelpFrenchLink() {
    storage.destroyConfigOnlineHelpFrenchLink();
}

export function getConfigOnlineHelpFrenchLink() {
    return storage.getConfigOnlineHelpFrenchLink();
}

// Config OnlineHelpEnglishLink
export function saveConfigOnlineHelpEnglishLink(value) {
    storage.saveConfigOnlineHelpEnglishLink(value);
}

export function destroyConfigOnlineHelpEnglishLink() {
    storage.destroyConfigOnlineHelpEnglishLink();
}

export function getConfigOnlineHelpEnglishLink() {
    return storage.getConfigOnlineHelpEnglishLink();
}

// Config CompanyTitle
export function saveConfigCompanyTitle(value) {
    storage.saveConfigCompanyTitle(value);
}

export function destroyConfigCompanyTitle() {
    storage.destroyConfigCompanyTitle();
}

export function getConfigCompanyTitle() {
    return storage.getConfigCompanyTitle();
}

// Config EntraId_Authority
export function saveConfigAuthority(value) {
    storage.saveConfigAuthority(value);
}

export function destroyConfigAuthority() {
    storage.destroyConfigAuthority();
}

export function getConfigAuthority() {
    return storage.getConfigAuthority();
}

// Config EntraId_RedirectUri
export function saveConfigRedirectUri(value) {
    storage.saveConfigRedirectUri(value);
}

export function destroyConfigRedirectUri() {
    storage.destroyConfigRedirectUri();
}

export function getConfigRedirectUri() {
    return storage.getConfigRedirectUri();
}

// Config EntraId_RedirectLogout
export function saveConfigRedirectLogout(value) {
    storage.saveConfigRedirectLogout(value);;
}

export function destroyConfigRedirectLogout() {
    storage.destroyConfigRedirectLogout();;
}

export function getConfigRedirectLogout() {
    return storage.getConfigRedirectLogout();
}

// Config IntervalWaitSSO
export function saveConfigIntervalWaitSSO(value) {
    storage.saveConfigIntervalWaitSSO(value);;
}

export function destroyConfigIntervalWaitSSO() {
    storage.destroyConfigIntervalWaitSSO();;
}

export function getConfigIntervalWaitSSO() {
    return storage.getConfigIntervalWaitSSO();
}

// ===== End Config File =====


// userCode
export function saveUserCode(value) {
    storage.saveUserCode(value?.toLowerCase());
}

export function destroyUserCode() {
    storage.destroyUserCode();
}

export function getUserCode() {
    return storage.getUserCode();
}

// userName
export function saveUserName(value) {
    storage.saveUserName(value);
}

export function destroyUserName() {
    storage.destroyUserName();
}

export function getUserName() {
    return storage.getUserName();
}

// employeeId
export function saveEmployeeId(value) {
    storage.saveEmployeeId(value);
}

export function destroyEmployeeId() {
    storage.destroyEmployeeId();
}

export function getEmployeeId() {
    return storage.getEmployeeId();
}


// menu
export function saveMenu(value) {
    storage.saveMenu(value);
}

export function destroyMenu() {
    storage.destroyMenu();
}

export function getMenu() {
    return storage.getMenu();
}

// favourites menus
export function saveFavouritesMenus(value) {
    storage.saveFavouritesMenus(value);
}

export function destroyFavouritesMenus() {
    storage.destroyFavouritesMenus();
}

export function getFavouritesMenus() {
    return storage.getFavouritesMenus();
}

// token
export function saveToken(value) {
    storage.saveToken(value);
}

export function destroyToken() {
    storage.destroyToken();
}

export function getToken() {
    return storage.getToken();
}


// sessionGuid
export function saveSessionGuid(value) {
    storage.saveSessionGuid(value);
}

export function destroySessionGuid() {
    storage.destroySessionGuid();
}

export function getSessionGuid() {
    return storage.getSessionGuid();
}


// abcUsage
export function saveAbcUsage(value) {
    storage.saveAbcUsage(value);
}

export function destroyAbcUsage() {
    storage.destroyAbcUsage();
}

export function getAbcUsage() {
    return storage.getAbcUsage();
}


// linkProjectPActivity
export function saveLinkProjectPActivity(value) {
    storage.saveLinkProjectPActivity(value);
}

export function destroyLinkProjectPActivity() {
    storage.destroyLinkProjectPActivity();
}

export function getLinkProjectPActivity() {
    return storage.getLinkProjectPActivity();
}


//googleApiKey
export function saveGoogleApiKey(value) {
    storage.saveGoogleApiKey(value);
}

export function destroyGoogleApiKey() {
    storage.destroyGoogleApiKey();
}

export function getGoogleApiKey() {
    return storage.getGoogleApiKey();
}


// expenseAccountActivities
export function saveExpenseAccountActivities(value) {
    storage.saveExpenseAccountActivities(value);
}

export function destroyExpenseAccountActivities() {
    storage.destroyExpenseAccountActivities();
}

export function getExpenseAccountActivities() {
    return storage.getExpenseAccountActivities();
}


// language
export function saveLanguage(value) {
    storage.saveLanguage(value);
}

export function destroyLanguage() {
    storage.destroyLanguage();
}

export function getLanguage() {
    return storage.getLanguage();
}

// timesheet
export function saveExpandedTimesheet(value) {
    storage.saveExpandedTimesheet(value);
}

export function destroyExpandedTimesheet() {
    storage.destroyExpandedTimesheet();
}

export function getExpandedTimesheet() {
    return storage.getExpandedTimesheet();
}

// StartDayTimesheet
export function saveStartDayTimesheet(value) {
    storage.saveStartDayTimesheet(value);
}

export function destroyStartDayTimesheet() {
    storage.destroyStartDayTimesheet();
}

export function getStartDayTimesheet() {
    return storage.getStartDayTimesheet();
}

// useTimeTimesheet
export function saveUseTimeTimesheet(value) {
    storage.saveUseTimeTimesheet(value);
}

export function destroyUseTimeTimesheet() {
    storage.destroyUseTimeTimesheet();
}

export function getUseTimeTimesheet() {
    return storage.getUseTimeTimesheet();
}


// useTimeTimesheetRequired
export function saveUseTimeTimesheetRequired(value) {
    storage.saveUseTimeTimesheetRequired(value);
}

export function destroyUseTimeTimesheetRequired() {
    storage.destroyUseTimeTimesheetRequired();
}

export function getUseTimeTimesheetRequired() {
    return storage.getUseTimeTimesheetRequired();
}

// acceptedTermsUse
export function saveAcceptedTermsUse(value) {
    storage.saveAcceptedTermsUse(value);
}

export function destroyAcceptedTermsUse() {
    storage.destroyAcceptedTermsUse();
}

export function getAcceptedTermsUse() {
    return storage.getAcceptedTermsUse();
}

// termsUse
export function saveTermsUse(value) {
    storage.saveTermsUse(value);
}

export function destroyTermsUse() {
    storage.destroyTermsUse();
}

export function getTermsUse() {
    return storage.getTermsUse();
}

// legalInfo
export function saveLegalInfo(value) {
    storage.saveLegalInfo(value);
}

export function destroyLegalInfo() {
    storage.destroyLegalInfo();
}

export function getLegalInfo() {
    return storage.getLegalInfo();
}

// showDateStatementTerms
export function saveShowDateStatementTerms(value) {
    storage.saveShowDateStatementTerms(value);
}

export function destroyShowDateStatementTerms() {
    storage.destroyShowDateStatementTerms();
}

export function getShowDateStatementTerms() {
    return storage.getShowDateStatementTerms();
}

// showDateStatementLegalInfo
export function saveShowDateStatementLegalInfo(value) {
    storage.saveShowDateStatementLegalInfo(value);
}

export function destroyShowDateStatementLegalInfo() {
    storage.destroyShowDateStatementLegalInfo();
}

export function getShowDateStatementLegalInfo() {
    return storage.getShowDateStatementLegalInfo();
}

// scheduleReturnDate
export function saveScheduleReturnDate(value) {
    storage.saveScheduleReturnDate(value);
}

export function destroyScheduleReturnDate() {
    storage.destroyScheduleReturnDate();
}

export function getScheduleReturnDate() {
    return storage.getScheduleReturnDate();
}

// filter
export function saveFilter(value, type) {
    if (type == pageSourceCode.CALENDAR) {
        storage.saveFilterCalendar(value);
    } else {
        storage.saveFilterRequest(value);
    }    
}

export function destroyFilter(type) {
    if (type == pageSourceCode.CALENDAR) {
        storage.destroyFilterCalendar();
    } else {
        storage.destroyFilterRequest();
    }     
}

export function getFilter(type) {
    if (type == pageSourceCode.CALENDAR) {
        return storage.getFilterCalendar();
    } else {
        return storage.getFilterRequest();
    }
}

// filterRequest
export function saveFilterRequest(value) {
    storage.saveFilterRequest(value);
}

export function destroyFilterRequest() {
    storage.destroyFilterRequest();
}

export function getFilterRequest() {
    return storage.getFilterRequest();
}

//HrRequestFilter
export function saveHrRequestFilter(value) {
    storage.saveHrRequestFilter(value);
}

export function destroyHrRequestFilter() {
    storage.destroyHrRequestFilter();
}

export function getHrRequestFilter() {
    return storage.getHrRequestFilter();
}

// filterCalendar
export function saveFilterCalendar(value) {
    storage.saveFilterCalendar(value);
}

export function destroyFilterCalendar() {
    storage.destroyFilterCalendar();
}

export function getFilterCalendar() {
    return storage.getFilterCalendar();
}

// isPasswordComplex
export function saveIsPasswordComplex(value) {
    storage.saveIsPasswordComplex(value);
}

export function destroyIsPasswordComplex() {
    storage.destroyIsPasswordComplex();
}

export function getIsPasswordComplex() {
    return storage.getIsPasswordComplex();
}

// minLengthPassword
export function saveMinLengthPassword(value) {
    storage.saveMinLengthPassword(value);
}

export function destroyMinLengthPassword() {
    storage.destroyMinLengthPassword();
}

export function getMinLengthPassword() {
    return storage.getMinLengthPassword();
}

// clientHashKey
export function saveClientHashKey(value) {
    storage.saveClientHashKey(value);
}

export function destroyClientHashKey() {
    storage.destroyClientHashKey();
}

export function getClientHashKey() {
    return storage.getClientHashKey();
}

// useGeolocation
export function saveUseGeolocation(value) {
    storage.saveUseGeolocation(value);
}

export function destroyUseGeolocation() {
    storage.destroyUseGeolocation();
}

export function getUseGeolocation() {
    return storage.getUseGeolocation();
}

// useGeolocationZone
export function saveUseGeolocationZone(value) {
    storage.saveUseGeolocationZone(value);
}

export function destroyUseGeolocationZone() {
    storage.destroyUseGeolocationZone();
}

export function getUseGeolocationZone() {
    return storage.getUseGeolocationZone();
}

// creditCardSupport
export function saveCreditCardSupport(value) {
    storage.saveCreditCardSupport(value);
}

export function destroyCreditCardSupport() {
    storage.destroyCreditCardSupport();
}

export function getCreditCardSupport() {
    return storage.getCreditCardSupport();
}

// companies
export function saveCompanies(value) {
    storage.saveCompanies(value);
}

export function destroyCompanies() {
    storage.destroyCompanies();
}

export function getCompanies() {
    return storage.getCompanies();
}

// punchTime
export function savePunchTime(value) {
    storage.savePunchTime(value);
}

export function destroyPunchTime() {
    storage.destroyPunchTime();
}

export function getPunchTime() {
    return storage.getPunchTime();
}

// colorCalendar
export function saveColorCalendar(value) {
    storage.saveColorCalendar(value);
}

export function destroyColorCalendar() {
    storage.destroyColorCalendar();
}

export function getColorCalendar() {
    return storage.getColorCalendar();
}

// UseWorkInstructions
export function saveUseWorkInstructions(value) {
    storage.saveUseWorkInstructions(value);
}

export function destroyUseWorkInstructions() {
    storage.destroyUseWorkInstructions();
}

export function getUseWorkInstructions() {
    return storage.getUseWorkInstructions();
}

// DisplayMedicalData
export function saveDisplayMedicalData(value) {
    storage.saveDisplayMedicalData(value);
}

export function destroyDisplayMedicalData() {
    storage.destroyDisplayMedicalData();
}

export function getDisplayMedicalData() {
    return storage.getDisplayMedicalData();
}

// DisplayDistributionSlip
export function saveDisplayDistributionSlip(value) {
    storage.saveDisplayDistributionSlip(value);
}

export function destroyDisplayDistributionSlip() {
    storage.destroyDisplayDistributionSlip();
}

export function getDisplayDistributionSlip() {
    return storage.getDisplayDistributionSlip();
}

// DisplayPreferenceCommunication
export function saveDisplayPreferenceCommunication(value) {
    storage.saveDisplayPreferenceCommunication(value);
}

export function destroyDisplayPreferenceCommunication() {
    storage.destroyDisplayPreferenceCommunication();
}

export function getDisplayPreferenceCommunication() {
    return storage.getDisplayPreferenceCommunication();
}

export function saveDisplaySeniorityDate(value) {
    storage.saveDisplaySeniorityDate(value);
}

export function destroyDisplaySeniorityDate() {
    storage.destroyDisplaySeniorityDate();
}

export function getDisplaySeniorityDate() {
    return storage.getDisplaySeniorityDate();
}

export function saveDisplayInactiveDate(value) {
    storage.saveDisplayInactiveDate(value);
}

export function destroyDisplayInactiveDate() {
    storage.destroyDisplayInactiveDate();
}

export function getDisplayInactiveDate() {
    return storage.getDisplayInactiveDate();
}

export function saveDisplayHiringDate(value) {
    storage.saveDisplayHiringDate(value);
}

export function destroyDisplayHiringDate() {
    storage.destroyDisplayHiringDate();
}

export function getDisplayHiringDate() {
    return storage.getDisplayHiringDate();
}

export function saveDisplayFirstDate(value) {
    storage.saveDisplayFirstDate(value);
}

export function destroyDisplayFirstDate() {
    storage.destroyDisplayFirstDate();
}

export function getDisplayFirstDate() {
    return storage.getDisplayFirstDate();
}

export function saveDisplayLastDate(value) {
    storage.saveDisplayLastDate(value);
}

export function destroyDisplayLastDate() {
    storage.destroyDisplayLastDate();
}

export function getDisplayLastDate() {
    return storage.getDisplayLastDate();
}

export function saveDisplayEmergencyContacts(value) {
    storage.saveDisplayEmergencyContacts(value);
}

export function destroyDisplayEmergencyContacts() {
    storage.destroyDisplayEmergencyContacts();
}

export function getDisplayEmergencyContacts() {
    return storage.getDisplayEmergencyContacts();
}

export function saveDisplayCCQClassifications(value) {
    storage.saveDisplayCCQClassifications(value);
}

export function destroyDisplayCCQClassifications() {
    storage.destroyDisplayCCQClassifications();
}

export function getDisplayCCQClassifications() {
    return storage.getDisplayCCQClassifications();
}

export function saveDisplayLastDevices(value) {
    storage.saveDisplayLastDevices(value);
}

export function destroyDisplayLastDevices() {
    storage.destroyDisplayLastDevices();
}

export function getDisplayLastDevices() {
    return storage.getDisplayLastDevices();
}

export function saveDisplayBankBalances(value) {
    storage.saveDisplayBankBalances(value);
}

export function destroyDisplayBankBalances() {
    storage.destroyDisplayBankBalances();
}

export function getDisplayBankBalances() {
    return storage.getDisplayBankBalances();
}

export function saveCanEmployeeChangePhoto(value) {
    storage.saveCanEmployeeChangePhoto(value);
}

export function destroyCanEmployeeChangePhoto() {
    storage.destroyCanEmployeeChangePhoto();
}

export function getCanEmployeeChangePhoto() {
    return storage.getCanEmployeeChangePhoto();
}

export function saveDisplayBankingInformation(value) {
    storage.saveDisplayBankingInformation(value);
}

export function destroyDisplayBankingInformation() {
    storage.destroyDisplayBankingInformation();
}

export function getDisplayBankingInformation() {
    return storage.getDisplayBankingInformation();
}

export function saveDisplayFlagFullTime(value) {
    storage.saveDisplayFlagFullTime(value);
}

export function destroyDisplayFlagFullTime() {
    storage.destroyDisplayFlagFullTime();
}

export function getDisplayFlagFullTime() {
    return storage.getDisplayFlagFullTime();
}

// IsCCQ
export function saveIsCCQ(value) {
    storage.saveIsCCQ(value);
}

export function destroyIsCCQ() {
    storage.destroyIsCCQ();
}

export function getIsCCQ() {
    return storage.getIsCCQ();
}

export function savePartialRequestHoursUsed(value) {
    storage.savePartialRequestHoursUsed(value);
}

export function destroyPartialRequestHoursUsed() {
    storage.destroyPartialRequestHoursUsed();
}

export function getPartialRequestHoursUsed() {
    return storage.getPartialRequestHoursUsed();
}

// ConnectionString
export function saveConnectionString(value) {
    storage.saveConnectionString(value);
}

export function destroyConnectionString() {
    storage.destroyConnectionString();
}

export function getConnectionString() {
    return storage.getConnectionString();
}

// TaxationProvince
export function saveTaxationProvince(value) {
    storage.saveTaxationProvince(value);
}

export function destroyTaxationProvince() {
    storage.destroyTaxationProvince();
}

export function getTaxationProvince() {
    return storage.getTaxationProvince();
}

// FilterExpenseAccount
export function saveFilterExpenseAccount(value) {
    storage.saveFilterExpenseAccount(value);
}

export function destroyFilterExpenseAccount() {
    storage.destroyFilterExpenseAccount();
}

export function getFilterExpenseAccount() {
    return storage.getFilterExpenseAccount();
}

// IsMandatoryPhoneCellPerso
export function saveIsMandatoryPhoneCellPerso(value) {
    storage.saveIsMandatoryPhoneCellPerso(value);
}

export function destroyIsMandatoryPhoneCellPerso() {
    storage.destroyIsMandatoryPhoneCellPerso();
}

export function getIsMandatoryPhoneCellPerso() {
    return storage.getIsMandatoryPhoneCellPerso();
}

// IsMandatoryEmailPerso
export function saveIsMandatoryEmailPerso(value) {
    storage.saveIsMandatoryEmailPerso(value);
}

export function destroyIsMandatoryEmailPerso() {
    storage.destroyIsMandatoryEmailPerso();
}

export function getIsMandatoryEmailPerso() {
    return storage.getIsMandatoryEmailPerso();
}

// IsMandatorySMSPerso
export function saveIsMandatorySMSPerso(value) {
    storage.saveIsMandatorySMSPerso(value);
}

export function destroyIsMandatorySMSPerso() {
    storage.destroyIsMandatorySMSPerso();
}

export function getIsMandatorySMSPerso() {
    return storage.getIsMandatorySMSPerso();
}

// CommunicationPreference
export function saveCommunicationPreference(value) {
    storage.saveCommunicationPreference(value);
}

export function destroyCommunicationPreference() {
    storage.destroyCommunicationPreference();
}

export function getCommunicationPreference() {
    return storage.getCommunicationPreference();
}

// IsDisplayPayAdvanceVacation
export function saveIsDisplayPayAdvanceVacation(value) {
    storage.saveIsDisplayPayAdvanceVacation(value);
}

export function destroyIsDisplayPayAdvanceVacation() {
    storage.destroyIsDisplayPayAdvanceVacation();
}

export function getIsDisplayPayAdvanceVacation() {
    return storage.getIsDisplayPayAdvanceVacation();
}

// IsUsePartialRequest
export function saveIsUsePartialRequest(value) {
    storage.saveIsUsePartialRequest(value);
}

export function destroyIsUsePartialRequest() {
    storage.destroyIsUsePartialRequest();
}

export function getIsUsePartialRequest() {
    return storage.getIsUsePartialRequest();
}

// IsSSO
export function saveIsSSO(value) {
    storage.saveIsSSO(value);
}

export function destroyIsSSO() {
    storage.destroyIsSSO();
}

export function getIsSSO() {
    return storage.getIsSSO();
}

// IsAuthSSO
export function saveIsAuthSSO(value) {
    storage.saveIsAuthSSO(value);
}

export function destroyIsAuthSSO() {
    storage.destroyIsAuthSSO();
}

export function getIsAuthSSO() {
    return storage.getIsAuthSSO();
}

// IsDisplayPayablesHours
export function saveIsDisplayPayablesHours(value) {
    storage.saveIsDisplayPayablesHours(value);
}

export function destroyIsDisplayPayablesHours() {
    storage.destroyIsDisplayPayablesHours();
}

export function getIsDisplayPayablesHours() {
    return storage.getIsDisplayPayablesHours();
}

// IsDisplayPayablesHours
export function saveIsUseMaterialResourceTimesheet(value) {
    storage.saveIsUseMaterialResourceTimesheet(value);
}

export function destroyIsUseMaterialResourceTimesheet() {
    storage.destroyIsUseMaterialResourceTimesheet();
}

export function getIsUseMaterialResourceTimesheet() {
    return storage.getIsUseMaterialResourceTimesheet();
}

// ShowSubscribe
export function saveShowSubscribe(value) {
    storage.saveShowSubscribe(value);
}

export function destroyShowSubscribe() {
    storage.destroyShowSubscribe();
}

export function getShowSubscribe() {
    return storage.getShowSubscribe();
}

// NotificationPublicKey
export function saveNotificationPublicKey(value) {
    storage.saveNotificationPublicKey(value);
}

export function destroyNotificationPublicKey() {
    storage.destroyNotificationPublicKey();
}

export function getNotificationPublicKey() {
    return storage.getNotificationPublicKey();
}

// NotificationPrivateKey
export function saveNotificationPrivateKey(value) {
    storage.saveNotificationPrivateKey(value);
}

export function destroyNotificationPrivateKey() {
    storage.destroyNotificationPrivateKey();
}

export function getNotificationPrivateKey() {
    return storage.getNotificationPrivateKey();
}

// IsNotificationActivate
export function saveIsNotificationActivate(value) {
    storage.saveIsNotificationActivate(value);
}

export function destroyIsNotificationActivate() {
    storage.destroyIsNotificationActivate();
}

export function getIsNotificationActivate() {
    return storage.getIsNotificationActivate();
}

// IsProfileConsultationMode
export function saveIsProfileConsultationMode(value) {
    storage.saveIsProfileConsultationMode(value);
}

export function destroyIsProfileConsultationMode() {
    storage.destroyIsProfileConsultationMode();
}

export function getIsProfileConsultationMode() {
    return storage.getIsProfileConsultationMode();
}

// ListPrefixConnection
export function saveListPrefixConnection(value) {
    storage.saveListPrefixConnection(value);
}

export function destroyListPrefixConnection() {
    storage.destroyListPrefixConnection();
}

export function getListPrefixConnection() {
    return storage.getListPrefixConnection();
}

// IsDisplayBankOthers
export function saveIsDisplayBankOthers(value) {
    storage.saveIsDisplayBankOthers(value);
}

export function destroyIsDisplayBankOthers() {
    storage.destroyIsDisplayBankOthers();
}

export function getIsDisplayBankOthers() {
    return storage.getIsDisplayBankOthers();
}

// IsDisplayBankVacation
export function saveIsDisplayBankVacation(value) {
    storage.saveIsDisplayBankVacation(value);
}

export function destroyIsDisplayBankVacation() {
    storage.destroyIsDisplayBankVacation();
}

export function getIsDisplayBankVacation() {
    return storage.getIsDisplayBankVacation();
}

// UseServiceProvider
export function saveUseServiceProvider(value) {
    storage.saveUseServiceProvider(value);
}

export function destroyUseServiceProvider() {
    storage.destroyUseServiceProvider();
}

export function getUseServiceProvider() {
    return storage.getUseServiceProvider();
}

// UseAttendanceConfirmation
export function saveUseAttendanceConfirmation(value) {
    storage.saveUseAttendanceConfirmation(value);
}

export function destroyUseAttendanceConfirmation() {
    storage.destroyUseAttendanceConfirmation();
}

export function getUseAttendanceConfirmation() {
    return storage.getUseAttendanceConfirmation();
}

// useGeolocationMandatory
export function saveUseGeolocationMandatory(value) {
    storage.saveUseGeolocationMandatory(value);
}

export function destroyUseGeolocationMandatory() {
    storage.destroyUseGeolocationMandatory();
}

export function getUseGeolocationMandatory() {
    return storage.getUseGeolocationMandatory();
}

// Worksites
export function saveWorksites(value) {
    storage.saveWorksites(value);
}

export function destroyWorksites() {
    storage.destroyWorksites();
}

export function getWorksites() {
    return storage.getWorksites();
}

// HasEmpAccess
export function saveHasEmpAccess(value) {
    storage.saveHasEmpAccess(value);
}

export function destroyHasEmpAccess() {
    storage.destroyHasEmpAccess();
}

export function getHasEmpAccess() {
    return storage.getHasEmpAccess();
}

// HasSupAccess
export function saveHasSupAccess(value) {
    storage.saveHasSupAccess(value);
}

export function destroyHasSupAccess() {
    storage.destroyHasSupAccess();
}

export function getHasSupAccess() {
    return storage.getHasSupAccess();
}

// IsOnCallFlag
export function saveIsOnCallFlag(value) {
    storage.saveIsOnCallFlag(value);
}

export function destroyIsOnCallFlag() {
    storage.destroyIsOnCallFlag();
}

export function getIsOnCallFlag() {
    return storage.getIsOnCallFlag();
}

// IsUseWorkorderInPunch
export function saveIsUseWorkorderInPunch(value) {
    storage.saveIsUseWorkorderInPunch(value);
}

export function destroyIsUseWorkorderInPunch() {
    storage.destroyIsUseWorkorderInPunch();
}

export function getIsUseWorkorderInPunch() {
    return storage.getIsUseWorkorderInPunch();
}

// IsProjectEntry
export function saveIsProjectEntry(value) {
    storage.saveIsProjectEntry(value);
}

export function destroyIsProjectEntry() {
    storage.destroyIsProjectEntry();
}

export function getIsProjectEntry() {
    return storage.getIsProjectEntry();
}

// IsActivityEntry
export function saveIsActivityEntry(value) {
    storage.saveIsActivityEntry(value);
}

export function destroyIsActivityEntry() {
    storage.destroyIsActivityEntry(value);
}

export function getIsActivityEntry() {
    return storage.getIsActivityEntry();
}

// IsTaskEntry
export function saveIsTaskEntry(value) {
    storage.saveIsTaskEntry(value);
}

export function destroyIsTaskEntry() {
    storage.destroyIsTaskEntry(value);
}

export function getIsTaskEntry() {
    return storage.getIsTaskEntry();
}

// IsUseAbc
export function saveIsUseAbc(value) {
    storage.saveIsUseAbc(value);
}

export function destroyIsUseAbc() {
    storage.destroyIsUseAbc(value);
}

export function getIsUseAbc() {
    return storage.getIsUseAbc();
}

// IsUseActivityRemark
export function saveIsUseActivityRemark(value) {
    storage.saveIsUseActivityRemark(value);
}

export function destroyIsUseActivityRemark() {
    storage.destroyIsUseActivityRemark(value);
}

export function getIsUseActivityRemark() {
    return storage.getIsUseActivityRemark();
}

// IsBlockAssocWorkorderInPunch
export function saveIsBlockAssocWorkorderInPunch(value) {
    storage.saveIsBlockAssocWorkorderInPunch(value);
}

export function destroyIsBlockAssocWorkorderInPunch() {
    storage.destroyIsBlockAssocWorkorderInPunch(value);
}

export function getIsBlockAssocWorkorderInPunch() {
    return storage.getIsBlockAssocWorkorderInPunch();
}

// UseOtherClassification
export function saveUseOtherClassification(value) {
    storage.saveUseOtherClassification(value);
}

export function destroyUseOtherClassification() {
    storage.destroyUseOtherClassification(value);
}

export function getUseOtherClassification() {
    return storage.getUseOtherClassification();
}

// IsUseOrderFormReq
export function saveIsUseOrderFormReq(value) {
    storage.saveIsUseOrderFormReq(value);
}

export function destroyIsUseOrderFormReq() {
    storage.destroyIsUseOrderFormReq(value);
}

export function getIsUseOrderFormReq() {
    return storage.getIsUseOrderFormReq();
}

// UseRequisitionCodeOnPunch
export function saveUseRequisitionCodeOnPunch(value) {
    storage.saveUseRequisitionCodeOnPunch(value);
}

export function destroyUseRequisitionCodeOnPunch() {
    storage.destroyUseRequisitionCodeOnPunch(value);
}

export function getUseRequisitionCodeOnPunch() {
    return storage.getUseRequisitionCodeOnPunch();
}

// UsePersonnelRequisitionMileage
export function saveUsePersonnelRequisitionMileage(value) {
    storage.saveUsePersonnelRequisitionMileage(value);
}

export function destroyUsePersonnelRequisitionMileage() {
    storage.destroyUsePersonnelRequisitionMileage(value);
}

export function getUsePersonnelRequisitionMileage() {
    return storage.getUsePersonnelRequisitionMileage();
}


// VacColor
export function saveVacColor(value) {
    storage.saveVacColor(value);
}

export function destroyVacColor() {
    storage.destroyVacColor(value);
}

export function getVacColor() {
    return storage.getVacColor();
}

// HolidayColor
export function saveHolidayColor(value) {
    storage.saveHolidayColor(value);
}

export function destroyHolidayColor() {
    storage.destroyHolidayColor(value);
}

export function getHolidayColor() {
    return storage.getHolidayColor();
}

// OffColor
export function saveOffColor(value) {
    storage.saveOffColor(value);
}

export function destroyOffColor() {
    storage.destroyOffColor(value);
}

export function getOffColor() {
    return storage.getOffColor();
}

// PshColor
export function savePshColor(value) {
    storage.savePshColor(value);
}

export function destroyPshColor() {
    storage.destroyPshColor(value);
}

export function getPshColor() {
    return storage.getPshColor();
}

// AbsColor
export function saveAbsColor(value) {
    storage.saveAbsColor(value);
}

export function destroyAbsColor() {
    storage.destroyAbsColor(value);
}

export function getAbsColor() {
    return storage.getAbsColor();
}

// UseDoubleApprobation
export function saveUseDoubleApprobation(value) {
    storage.saveUseDoubleApprobation(value);
}

export function destroyUseDoubleApprobation() {
    storage.destroyUseDoubleApprobation(value);
}

export function getUseDoubleApprobation() {
    return storage.getUseDoubleApprobation();
}

// ApprobationStructure
export function saveApprobationStructure(value) {
    storage.saveApprobationStructure(value);
}

export function destroyApprobationStructure() {
    storage.destroyApprobationStructure(value);
}

export function getApprobationStructure() {
    return storage.getApprobationStructure();
}

// IsLevel2Approbator
export function saveIsLevel2Approbator(value) {
    storage.saveIsLevel2Approbator(value);
}

export function destroyIsLevel2Approbator() {
    storage.destroyIsLevel2Approbator(value);
}

export function getIsLevel2Approbator() {
    return storage.getIsLevel2Approbator();
}

// IsApprobationLv1Mandatory
export function saveIsApprobationLv1Mandatory(value) {
    storage.saveIsApprobationLv1Mandatory(value);
}

export function destroyIsApprobationLv1Mandatory() {
    storage.destroyIsApprobationLv1Mandatory(value);
}

export function getIsApprobationLv1Mandatory() {
    return storage.getIsApprobationLv1Mandatory();
}

// IsUseCCQStatus
export function saveIsUseCCQStatus(value) {
    storage.saveIsUseCCQStatus(value);
}

export function destroyIsUseCCQStatus() {
    storage.destroyIsUseCCQStatus();
}

export function getIsUseCCQStatus() {
    return storage.getIsUseCCQStatus();
}

// IsUseCCQTask
export function saveIsUseCCQTask(value) {
    storage.saveIsUseCCQTask(value);
}

export function destroyIsUseCCQTask() {
    storage.destroyIsUseCCQTask();
}

export function getIsUseCCQTask() {
    return storage.getIsUseCCQTask();
}

// IsDisplayChatMenu
export function saveIsDisplayChatMenu(value) {
    storage.saveIsDisplayChatMenu(value);
}

export function destroyIsDisplayChatMenu() {
    storage.destroyIsDisplayChatMenu();
}

export function getIsDisplayChatMenu() {
    return storage.getIsDisplayChatMenu();
}

// IsDisplayExpenseAccountClassif
export function saveIsDisplayExpenseAccountClassif(value) {
    storage.saveIsDisplayExpenseAccountClassif(value);
}

export function destroyIsDisplayExpenseAccountClassif() {
    storage.destroyIsDisplayExpenseAccountClassif();
}

export function getIsDisplayExpenseAccountClassif() {
    return storage.getIsDisplayExpenseAccountClassif();
}

// IsSuperUser
export function saveIsSuperUser(value) {
    storage.saveIsSuperUser(value);
}

export function destroyIsSuperUser() {
    storage.destroyIsSuperUser();
}

export function getIsSuperUser() {
    return storage.getIsSuperUser();
}

// AllowConsultation
export function saveAllowConsultation(value) {
    storage.saveAllowConsultation(value);
}

export function destroyAllowConsultation() {
    storage.destroyAllowConsultation();
}

export function getAllowConsultation() {
    return storage.getAllowConsultation();
}

// IsRefusalRequestMandatoryComment
export function saveIsRefusalRequestMandatoryComment(value) {
    storage.saveIsRefusalRequestMandatoryComment(value);
}

export function destroyIsRefusalRequestMandatoryComment() {
    storage.destroyIsRefusalRequestMandatoryComment();
}

export function getIsRefusalRequestMandatoryComment() {
    return storage.getIsRefusalRequestMandatoryComment();
}

// selectedMenu
export function saveSelectedMenu(value) {
    storage.saveSelectedMenu(value);
}

export function destroySelectedMenu() {
    storage.destroySelectedMenu();
}

export function getSelectedMenu() {
    return storage.getSelectedMenu();
}

// redirectMenu
export function saveRedirectMenu(value) {
    storage.saveRedirectMenu(value);
}

export function destroyRedirectMenu() {
    storage.destroyRedirectMenu();
}

export function getRedirectMenu() {
    return storage.getRedirectMenu();
}

// AllowConsultation
export function saveAllowApprobation(value) {
    storage.saveAllowApprobation(value);
}

export function destroyAllowApprobation() {
    storage.destroyAllowApprobation();
}

export function getAllowApprobation() {
    return storage.getAllowApprobation();
}

// IsActivityAssocWorkorderInPunch
export function saveIsActivityAssocWorkorderInPunch(value) {
    storage.saveIsActivityAssocWorkorderInPunch(value);
}

export function destroyIsActivityAssocWorkorderInPunch() {
    storage.destroyIsActivityAssocWorkorderInPunch();
}

export function getIsActivityAssocWorkorderInPunch() {
    return storage.getIsActivityAssocWorkorderInPunch();
}

// IsUseBankExtraTime
export function saveIsUseBankExtraTime(value) {
    storage.saveIsUseBankExtraTime(value);
}

export function destroyIsUseBankExtraTime() {
    storage.destroyIsUseBankExtraTime();
}

export function getIsUseBankExtraTime() {
    return storage.getIsUseBankExtraTime();
}

// IsUseExtraTimePay
export function saveIsUseExtraTimePay(value) {
    storage.saveIsUseExtraTimePay(value);
}

export function destroyIsUseExtraTimePay() {
    storage.destroyIsUseExtraTimePay();
}

export function getIsUseExtraTimePay() {
    return storage.getIsUseExtraTimePay();
}

// IsUseWorkorder
export function saveIsUseWorkorder(value) {
    storage.saveIsUseWorkorder(value);
}

export function destroyIsUseWorkorder() {
    storage.destroyIsUseWorkorder();
}

export function getIsUseWorkorder() {
    return storage.getIsUseWorkorder();
}

// IsDepartmentMandatoryOnProject
export function saveIsDepartmentMandatoryOnProject(value) {
    storage.saveIsDepartmentMandatoryOnProject(value);
}

export function destroyIsDepartmentMandatoryOnProject() {
    storage.destroyIsDepartmentMandatoryOnProject();
}

export function getIsDepartmentMandatoryOnProject() {
    return storage.getIsDepartmentMandatoryOnProject();
}

// IsPayProjectWithSkills
export function saveIsPayProjectWithSkills(value) {
    storage.saveIsPayProjectWithSkills(value);
}

export function destroyIsPayProjectWithSkills() {
    storage.destroyIsPayProjectWithSkills();
}

export function getIsPayProjectWithSkills() {
    return storage.getIsPayProjectWithSkills();
}

// CommentForApprovOnPunch
export function saveCommentForApprovOnPunch(value) {
    storage.saveCommentForApprovOnPunch(value);
}

export function destroyCommentForApprovOnPunch() {
    storage.destroyCommentForApprovOnPunch();
}

export function getCommentForApprovOnPunch() {
    return storage.getCommentForApprovOnPunch();
}

// DefaultSubcodTransacWithExtraTimeBank
export function saveDefaultSubcodTransacWithExtraTimeBank(value) {
    storage.saveDefaultSubcodTransacWithExtraTimeBank(value);
}

export function destroyDefaultSubcodTransacWithExtraTimeBank() {
    storage.destroyDefaultSubcodTransacWithExtraTimeBank();
}

export function getDefaultSubcodTransacWithExtraTimeBank() {
    return storage.getDefaultSubcodTransacWithExtraTimeBank();
}

// DefaultSubcodTransacWithExtraTimePay
export function saveDefaultSubcodTransacWithExtraTimePay(value) {
    storage.saveDefaultSubcodTransacWithExtraTimePay(value);
}

export function destroyDefaultSubcodTransacWithExtraTimePay() {
    storage.destroyDefaultSubcodTransacWithExtraTimePay();
}

export function getDefaultSubcodTransacWithExtraTimePay() {
    return storage.getDefaultSubcodTransacWithExtraTimePay();
}

// DefaultABCProjectHoliday
export function saveDefaultABCProjectHoliday(value) {
    storage.saveDefaultABCProjectHoliday(value);
}

export function destroyDefaultABCProjectHoliday() {
    storage.destroyDefaultABCProjectHoliday();
}

export function getDefaultABCProjectHoliday() {
    return storage.getDefaultABCProjectHoliday();
}

// DefaultABCProjectHolidayCrypt
export function saveDefaultABCProjectHolidayCrypt(value) {
    storage.saveDefaultABCProjectHolidayCrypt(value);
}

export function destroyDefaultABCProjectHolidayCrypt() {
    storage.destroyDefaultABCProjectHolidayCrypt();
}

export function getDefaultABCProjectHolidayCrypt() {
    return storage.getDefaultABCProjectHolidayCrypt();
}

// DefaultABCActivityHoliday
export function saveDefaultABCActivityHoliday(value) {
    storage.saveDefaultABCActivityHoliday(value);
}

export function destroyDefaultABCActivityHoliday() {
    storage.destroyDefaultABCActivityHoliday();
}

export function getDefaultABCActivityHoliday() {
    return storage.getDefaultABCActivityHoliday();
}

// DefaultABCActivityHolidayCrypt
export function saveDefaultABCActivityHolidayCrypt(value) {
    storage.saveDefaultABCActivityHolidayCrypt(value);
}

export function destroyDefaultABCActivityHolidayCrypt() {
    storage.destroyDefaultABCActivityHolidayCrypt();
}

export function getDefaultABCActivityHolidayCrypt() {
    return storage.getDefaultABCActivityHolidayCrypt();
}

// DefaultPayProjectHoliday
export function saveDefaultPayProjectHoliday(value) {
    storage.saveDefaultPayProjectHoliday(value);
}

export function destroyDefaultPayProjectHoliday() {
    storage.destroyDefaultPayProjectHoliday();
}

export function getDefaultPayProjectHoliday() {
    return storage.getDefaultPayProjectHoliday();
}

// DefaultPayActivityHoliday
export function saveDefaultPayActivityHoliday(value) {
    storage.saveDefaultPayActivityHoliday(value);
}

export function destroyDefaultPayActivityHoliday() {
    storage.destroyDefaultPayActivityHoliday();
}

export function getDefaultPayActivityHoliday() {
    return storage.getDefaultPayActivityHoliday();
}

// DefaultPayTaskHoliday
export function saveDefaultPayTaskHoliday(value) {
    storage.saveDefaultPayTaskHoliday(value);
}

export function destroyDefaultPayTaskHoliday() {
    storage.destroyDefaultPayTaskHoliday();
}

export function getDefaultPayTaskHoliday() {
    return storage.getDefaultPayTaskHoliday();
}

// DefaultWorkOrder
export function saveDefaultWorkOrder(value) {
    storage.saveDefaultWorkOrder(value);
}

export function destroyDefaultWorkOrder() {
    storage.destroyDefaultWorkOrder();
}

export function getDefaultWorkOrder() {
    return storage.getDefaultWorkOrder();
}

// HasEmploymentStatusOnShift
export function saveHasEmploymentStatusOnShift(value) {
    storage.saveHasEmploymentStatusOnShift(value);
}

export function destroyHasEmploymentStatusOnShift() {
    storage.destroyHasEmploymentStatusOnShift();
}

export function getHasEmploymentStatusOnShift() {
    return storage.getHasEmploymentStatusOnShift();
}

// IsDisplayJobTitleProfileByDepartment
export function saveIsDisplayJobTitleProfileByDepartment(value) {
    storage.saveIsDisplayJobTitleProfileByDepartment(value);
}

export function destroyIsDisplayJobTitleProfileByDepartment() {
    storage.destroyIsDisplayJobTitleProfileByDepartment();
}

export function getIsDisplayJobTitleProfileByDepartment() {
    return storage.getIsDisplayJobTitleProfileByDepartment();
}

// IsDisplayPayProjectProfileByDepartment
export function saveIsDisplayPayProjectProfileByDepartment(value) {
    storage.saveIsDisplayPayProjectProfileByDepartment(value);
}

export function destroyIsDisplayPayProjectProfileByDepartment() {
    storage.destroyIsDisplayPayProjectProfileByDepartment();
}

export function getIsDisplayPayProjectProfileByDepartment() {
    return storage.getIsDisplayPayProjectProfileByDepartment();
}

// IsDisplayShiftProfileByProject
export function saveIsDisplayShiftProfileByProject(value) {
    storage.saveIsDisplayShiftProfileByProject(value);
}

export function destroyIsDisplayShiftProfileByProject() {
    storage.destroyIsDisplayShiftProfileByProject();
}

export function getIsDisplayShiftProfileByProject() {
    return storage.getIsDisplayShiftProfileByProject();
}

// IsDisplaySubcodeProfileByDepartment
export function saveIsDisplaySubcodeProfileByDepartment(value) {
    storage.saveIsDisplaySubcodeProfileByDepartment(value);
}

export function destroyIsDisplaySubcodeProfileByDepartment() {
    storage.destroyIsDisplaySubcodeProfileByDepartment();
}

export function getIsDisplaySubcodeProfileByDepartment() {
    return storage.getIsDisplaySubcodeProfileByDepartment();
}

// IsDisplaySubcodeProfileByJobTitle
export function saveIsDisplaySubcodeProfileByJobTitle(value) {
    storage.saveIsDisplaySubcodeProfileByJobTitle(value);
}

export function destroyIsDisplaySubcodeProfileByJobTitle() {
    storage.destroyIsDisplaySubcodeProfileByJobTitle();
}

export function getIsDisplaySubcodeProfileByJobTitle() {
    return storage.getIsDisplaySubcodeProfileByJobTitle();
}

// IsDisplaySubcodeProfileByProject
export function saveIsDisplaySubcodeProfileByProject(value) {
    storage.saveIsDisplaySubcodeProfileByProject(value);
}

export function destroyIsDisplaySubcodeProfileByProject() {
    storage.destroyIsDisplaySubcodeProfileByProject();
}

export function getIsDisplaySubcodeProfileByProject() {
    return storage.getIsDisplaySubcodeProfileByProject();
}

// IsLinkProjectActivityTaskP
export function saveIsLinkProjectActivityTaskP(value) {
    storage.saveIsLinkProjectActivityTaskP(value);
}

export function destroyIsLinkProjectActivityTaskP() {
    storage.destroyIsLinkProjectActivityTaskP();
}

export function getIsLinkProjectActivityTaskP() {
    return storage.getIsLinkProjectActivityTaskP();
}

// IsProjAssocWorkorderInPunch
export function saveIsProjAssocWorkorderInPunch(value) {
    storage.saveIsProjAssocWorkorderInPunch(value);
}

export function destroyIsProjAssocWorkorderInPunch() {
    storage.destroyIsProjAssocWorkorderInPunch();
}

export function getIsProjAssocWorkorderInPunch() {
    return storage.getIsProjAssocWorkorderInPunch();
}

// IsDefaultApprovManEntryApprovalPortal
export function saveIsDefaultApprovManEntryApprovalPortal(value) {
    storage.saveIsDefaultApprovManEntryApprovalPortal(value);
}

export function destroyIsDefaultApprovManEntryApprovalPortal() {
    storage.destroyIsDefaultApprovManEntryApprovalPortal();
}

export function getIsDefaultApprovManEntryApprovalPortal() {
    return storage.getIsDefaultApprovManEntryApprovalPortal();
}

// IsJobTitleEntry
export function saveIsJobTitleEntry(value) {
    storage.saveIsJobTitleEntry(value);
}

export function destroyIsJobTitleEntry() {
    storage.destroyIsJobTitleEntry();
}

export function getIsJobTitleEntry() {
    return storage.getIsJobTitleEntry();
}

// IsPayProjectLoadedFromWorkorder
export function saveIsPayProjectLoadedFromWorkorder(value) {
    storage.saveIsPayProjectLoadedFromWorkorder(value);
}

export function destroyIsPayProjectLoadedFromWorkorder() {
    storage.destroyIsPayProjectLoadedFromWorkorder();
}

export function getIsPayProjectLoadedFromWorkorder() {
    return storage.getIsPayProjectLoadedFromWorkorder();
}

// IsWorkOrderLinkedToDepartment
export function saveIsWorkOrderLinkedToDepartment(value) {
    storage.saveIsWorkOrderLinkedToDepartment(value);
}

export function destroyIsWorkOrderLinkedToDepartment() {
    storage.destroyIsWorkOrderLinkedToDepartment();
}

export function getIsWorkOrderLinkedToDepartment() {
    return storage.getIsWorkOrderLinkedToDepartment();
}

// UseFilePunch
export function saveUseFilePunch(value) {
    storage.saveUseFilePunch(value);
}

export function destroyUseFilePunch() {
    storage.destroyUseFilePunch();
}

export function getUseFilePunch() {
    return storage.getUseFilePunch();
}

// useDailyReport
export function saveUseDailyReport(value) {
    storage.saveUseDailyReport(value);
}

export function destroyUseDailyReport() {
    storage.destroyUseDailyReport();
}

export function getUseDailyReport() {
    return storage.getUseDailyReport();
}

// useEventReport
export function saveUseEventReport(value) {
    storage.saveUseEventReport(value);
}

export function destroyUseEventReport() {
    storage.destroyUseEventReport();
}

export function getUseEventReport() {
    return storage.getUseEventReport();
}